import {curveMonotoneX, line, scaleLinear, axisBottom, axisLeft, easeLinear, format, min, max} from 'd3'
import _ from 'underscore'

export const path = line().curve(curveMonotoneX)

export const kvalNotation = format('.3s')

export const drawLineChart = props => {
    const { height, width, classSelector, data } = props
    const now = new Date()
    const yDomain = [0, 260000]
    // const xDomain = [now - (n - 2) * 750, now - 750]
    const yScale = scaleLinear().range([height / 2, 0]).domain(yDomain)
    const xScale = scaleLinear().range([0, width / 3])//.domain(xDomain)
    const chart = selection => {
        const g = selection.select('svg').select(classSelector)
        const xAxis = g.select('.axis.axis--x')
        const yAxis = g.select('.axis.axis--y')
        const uniq = _.uniq(data, o => o.properties.name)
        const circle = g.selectAll('circle').data(uniq)
        const text = g.selectAll('.neigh-text').data(uniq)

        path.x(d => xScale(d.properties.ts)).y(d => yScale(d.properties.dp03_0062e)) // Define xScale and yScale based on your setup.
        xScale.domain([min(data, d => d.properties.ts), max(data, d => d.properties.ts)])

        xAxis
            .call(axisBottom(xScale).ticks(0))
        yAxis
            .call(axisLeft(yScale).tickFormat(kvalNotation))
        // g
        //     .select('.income-line')
        //     .datum(uniq)
        //     .attr('d', path(uniq))
        //     .style('fill', 'none')
        //     .style('stroke', '#e74c3c')
        //     .style('stroke-width', 2)
        //     .attr('transform', 'translate(50,0)')
        //
        // circle.exit().remove()
        // circle.enter().append('circle')
        //
        // circle
        //     .attr('class', 'station-circle')
        //     .attr('cx', d => xScale(d.properties.ts))
        //     .attr('cy', d => yScale(d.properties.dp03_0062e))
        //     .attr('r', 3)
        //     .style('stroke-width', 1)
        //     .style('stroke','red')
        //     .style('fill', 'white')
        //     .attr('transform', `translate(50,0)`)
        //
        // text.exit().remove()
        // text.enter().append('text').attr('class', 'neigh-text')
        // text
        //     .attr('x', d => xScale(d.properties.ts) )
        //     .attr('y', d => yScale(d.properties.dp03_0062e))
        //     .style('text-shadow', '0 0 1px darkgrey, 0 0 2px lightgrey, 0 0 4px grey, 0 0 5px white')
        //     .html(d => {
        //         const x = xScale(d.properties.ts)
        //         return `<tspan style="font-weight:bold;" dy="-10" x={x}>${ d.properties.name }</tspan><tspan dy="12" x=${x}>$${ kvalNotation(d.properties.dp03_0062e) }</tspan>`
        //     })
    }
    return chart
}
